import { makeGet } from './ServiceManager';

export const getPresentations = async () => {
  const result = await makeGet('service/presentations/presentations');
  return result;
};



// WEBPACK FOOTER //
// ./src/services/PresentationManager.js